import { useState, useEffect } from 'react';
import trackSort from '@helpers/analyticsHelpers/trackSort';
import type { SortData, AxfoodProductBannerComponentViewModel } from '@occ/api-client';
import { usePathname, useSearchParams, useRouter } from 'next/navigation';

const useSortOptions = (
  component: AxfoodProductBannerComponentViewModel | null | undefined,
  displayFilters?: boolean
) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [sortOptions, setSortOptions] = useState<OptionType[] | null>(null);

  const getSortOptions = (sorts: Array<SortData>): OptionType[] => {
    return sorts?.map((sort) => {
      const { code: value, name, selected } = sort;
      return { value: value as string, label: name as string, selected: selected as boolean };
    });
  };

  const getSelectedSort = () => sortOptions?.find((s) => s.selected);

  const onSort = (option: OptionType) => {
    if (!pathname) return;

    const selectedSort = getSelectedSort();
    if (option.value !== selectedSort?.value) {
      // Convert searchParams to object
      const currentParams = searchParams ? Object.fromEntries(searchParams.entries()) : {};
      const queryParams = { ...currentParams, sort: option.value };

      trackSort('my_most_bought_page', option?.label);

      // Build URL with query string
      const queryString = new URLSearchParams(queryParams as any).toString();
      const newPath = queryString ? `${pathname}?${queryString}` : pathname;

      router.push(newPath);
    }
  };

  useEffect(() => {
    if (displayFilters && component?.sorts) {
      setSortOptions(getSortOptions(component.sorts));
    }
  }, [component, displayFilters]);

  return { sortOptions, onSort };
};

export default useSortOptions;
